import classNames from 'styles/utils/classNames';
import Heart from 'svg/Heart';
import Share from 'svg/Share';
import { Button } from 'components/Button';

interface Props {
  isFollowing: boolean;
  isFollowDisabled: boolean;
  onToggleFollow: () => void;
  onShare: () => void;
}

export default function AsideActions({
  isFollowing,
  isFollowDisabled,
  onToggleFollow,
  onShare,
}: Props) {
  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-ds-lg">
        <button
          type="button"
          onClick={onShare}
          className="typography-product-button-label-large flex items-center gap-1.5 text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
        >
          <Share className="w-5" />
          Share
        </button>
        <button
          type="button"
          disabled={isFollowDisabled}
          onClick={onToggleFollow}
          className={classNames(
            'typography-product-button-label-large flex items-center gap-1.5 disabled:cursor-not-allowed',
            isFollowing
              ? 'text-color-text-brand'
              : 'text-color-text-lightmode-primary dark:text-color-text-darkmode-primary',
          )}
        >
          <Heart className="w-5" />
          {isFollowing ? 'Favorited' : 'Add to favorite'}
        </button>
      </div>
      <Button
        variant="primary"
        size="md"
        isInline
        disabled={isFollowDisabled}
        onClick={onToggleFollow}
      >
        {isFollowing ? 'Following' : 'Follow'}
      </Button>
    </div>
  );
}
